<template>
  <UIDrawer
    :is-open
    :title
    :z-index
    :allow-tray
    @minimize="handleMinimize"
    @close="handleClose"
  >
    <ContactForm :instance="modal.entity" @close="handleClose" />
  </UIDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ContactClass } from '..'
import { ModalClass } from '@types'

import { CONTACT_MODAL_TITLE, CONTACT_MODAL_TITLE_NEW } from './utils/const'

import { UIDrawer } from '@ui/modals'
import ContactForm from './ContactForm.vue'

type Props = {
  modal: ModalClass<ContactClass>
}

const props = defineProps<Props>()

const title = computed(() =>
  props.modal.entity.isNew ? CONTACT_MODAL_TITLE_NEW : CONTACT_MODAL_TITLE,
)

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)
const allowTray = computed(() => props.modal.allowTray)

const handleMinimize = () => {
  props.modal.hide()
}

const handleClose = () => {
  props.modal.conditionalClose()
}
</script>
